import { BelgiumPOSValues } from 'components/Onboarding/types';

export const template = (id: string): BelgiumPOSValues => ({
  country: 'be',
  id,
  terminalId: '',
  terminalProvider: '',
});
